import React, { Component } from 'react';
import {Route,Switch} from 'react-router-dom';
import asyncComponent from './component/AsyncComponent/AsyncComponent';
//趣帮
//import ChessBangRoute from './component/Route/chessbang';
const ChessBangRoute = asyncComponent(()=>import("./component/Route/chessbang"))
//蓝宝书
//import BlueBook from './component/Route/bluebookRoute';
const BlueBook = asyncComponent(()=>import("./component/Route/bluebookRoute"))
//测试出题
const BlueTour = asyncComponent(()=>import("./component/Route/blueTour"))
//好棋App下载页面
const AppUpdate = asyncComponent(()=>import("./component/Route/appUpdate"))
//测评
const BlueEval = asyncComponent(()=>import("./component/Route/BlueEval"))
//题目筛选
const PuzzFilter = asyncComponent(()=>import("./component/Route/puzzleFilter"))
class App extends Component {

  render() {

    return (
      <div>
          <Switch>
            {/* 测试出题 */}
            <Route exc path='/bluetour' component={BlueTour} />
            {/* 蓝宝书 */}
            <Route exc path='/bluebook' component={BlueBook} />
            {/* 蓝宝书测评活动 */}
            <Route exc path='/blueeval' component={BlueEval} />    
             {/* 题目筛选 */}
             <Route exc path='/puzzfilter' component={PuzzFilter} />                         
            {/* 好棋app下载页面 */}
             <Route exc path='/appupdate' component={AppUpdate} />
             {/* 趣帮 */}
            <Route exc path='/' component={ChessBangRoute}/>
          </Switch>
      </div>
    );
  }
}

export default App;
